import { StatisticsApi } from './index';
import * as Type from './types';

export default class FaqStats extends StatisticsApi.default {
  trackView(payload: Type.ViewPayload): Promise<Response> {
    if (this.isNewSession && !this.viewHasBeenTracked) {
      this.viewHasBeenTracked = true;

      return this.track(Type.StatType.View, payload);
    }
  }

  trackSearch(payload: Type.SearchPayload): Promise<Response> {
    return this.track(Type.StatType.Search, payload);
  }

  trackOpenQuestion(payload: Type.OpenQuestionPayload): Promise<Response> {
    return this.track(Type.StatType.OpenQuestion, payload);
  }
}
